import { SiteHeader } from "./site-chrome";

export function StorefrontLoadingPage({ message }: { message: string }) {
  return (
    <div className="storefront-shell storefront-shell--warm-product" dir="rtl">
      <SiteHeader cartQuantity={0} />
      <main
        className="storefront-status-page"
        aria-busy="true"
        aria-live="polite"
      >
        <p role="status">{message}</p>
      </main>
    </div>
  );
}
